import { useState, useEffect, useRef } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Typography,
  Box,
  Tooltip,
  Autocomplete,
  IconButton,
  Dialog,
  DialogTitle,
  TextField,
  DialogActions,
  Button,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseDeliveryManage } from "./UseDeliveryManage";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import ShortcutIcon from "@mui/icons-material/Shortcut";
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function DeliveriesGrid(props) {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const orderCTF = useRef(null);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const {
    getOrdersByDeliveryDate,
    CancelDeliveryOrder,
    getPlatforms,
    AddPlatform,
  } = UseDeliveryManage();
  const { myPc, updatePage, updateSort, refresh } = UseMyPC("platform", "desc");
  const [openDialog, setOpenDialog] = useState(false);
  const [platformModel, setPlatformModel] = useState({
    orderID: undefined,
    deliveryDate: undefined,
    deliveryPart: undefined,
    platformid: undefined,
  });
  const { isSmall } = useBreakpoints();
  const [platforms, setPlatforms] = useState();
  const [orderRes, setOrderRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    if (props.filters.deliveryDate && props.filters.deliveryPart) {
      updatePage(1);
    }
  }, [props.filters]);

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    if (props.filters.deliveryDate && props.filters.deliveryPart) {
      // setProgress(true);
      getOrdersByDeliveryDate(
        myPc,
        props.filters.deliveryDate,
        props.filters.deliveryPart,
        (orders) => {
          if (orders) {
            setPlatformModel({
              ...platformModel,
              orderID: undefined,
              deliveryDate: orders.deliveryDate.split("T")[0],
              deliveryPart: orders.deliveryPart,
            });
            setOrderRes(orders);
          } else {
            setOrderRes();
          }
        },
        true
      );
    }
  }, [myPc, props.filters]);

  useEffect(() => {
    setProgress(true);
    getPlatforms((Platform) => {
      let newPlatforms = Platform.map((m) => {
        m.id = m.id + 1;
        return m;
      });
      setPlatforms(newPlatforms);
    });
  }, []);

  useEffect(() => {
    refresh();
  }, []);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "orderID",
      width: 100,
      align: "center",
      headerName: "سفارش",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setPlatformModel({
                ...platformModel,
                orderID: cellValues.row.orderID,
              });
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cellValues.row.orderID}
          </Typography>
        );
      },
    },
    {
      field: "fullname",
      headerName: "نام مشتری",
      width: 180,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setPlatformModel({
                ...platformModel,
                orderID: cellValues.row.orderID,
              });
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cellValues.row.fullname}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: "موبایل",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setPlatformModel({
                ...platformModel,
                orderID: cellValues.row.orderID,
              });
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cellValues.row.mobile}
          </Typography>
        );
      },
    },
    {
      field: "platform",
      headerName: "لجستیک",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setPlatformModel({
                ...platformModel,
                orderID: cellValues.row.orderID,
              });
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cellValues.row.platform}
          </Typography>
        );
      },
    },
    {
      field: "state",
      headerName: "وضعیت",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setPlatformModel({
                ...platformModel,
                orderID: cellValues.row.orderID,
              });
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cellValues.row.state}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 100,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="انتقال سفارش">
              <IconButton
                onClick={() => {
                  if (platformModel.platformid == undefined) {
                    enqueueSnackbar("لجستیک ارسال را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  let platform = {
                    orderID: cellValues.row.orderID,
                    deliveryDate: platformModel.deliveryDate,
                    deliveryPart: platformModel.deliveryPart,
                    platformid: platformModel.platformid,
                  };
                  AddPlatform(platform, (callback) => {
                    setProgress(true);
                    getOrdersByDeliveryDate(
                      myPc,
                      platformModel.deliveryDate,
                      platformModel.deliveryPart,
                      (orders) => {
                        // orderCTF.current.focus();
                        if (orders) {
                          setPlatformModel({
                            ...platformModel,
                            orderID: "",
                            deliveryDate: orders.deliveryDate.split("T")[0],
                            deliveryPart: orders.deliveryPart,
                          });
                          setOrderRes(orders);
                        } else {
                          setOrderRes();
                        }
                      },
                      false
                    );
                  });
                  // setPlatformModel({
                  //   ...platformModel,
                  //   orderID: cellValues.row.orderID,
                  //   // orderID: cellValues.row.orderID,
                  // });
                }}
              >
                <ShortcutIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            {cellValues.row.stateID == 9 ? (
              <Tooltip title="عدم لغو سفارش">
                <IconButton
                  onClick={() => {
                    setDeleteState({
                      show: true,
                      name: "عدم لغو",
                      model: { id: cellValues.row.id, cancel: false },
                    });
                  }}
                >
                  <RestoreFromTrashIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="لغو سفارش">
                <IconButton
                  onClick={() => {
                    setDeleteState({
                      show: true,
                      name: "لغو",
                      model: { id: cellValues.row.id, cancel: true },
                    });
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    },

    {
      field: "address",
      headerName: "آدرس",
      width: 350,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setPlatformModel({
                ...platformModel,
                orderID: cellValues.row.orderID,
              });
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "left",
              display: "flex",
              alignItems: "center",
              justifyContent: "left",
            }}
          >
            {cellValues.row.address}
          </Typography>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "100%" }}>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          آیا از انتقال همه سفارشات اطمینان دارید؟
        </DialogTitle>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() => {
              let platform = {
                orderID: -1,
                deliveryDate: platformModel.deliveryDate,
                deliveryPart: platformModel.deliveryPart,
                platformid: platformModel.platformid,
              };
              // return;
              setProgress(true);
              setOpenDialog(false);
              AddPlatform(platform, (callback) => {
                setProgress(true);
                getOrdersByDeliveryDate(
                  myPc,
                  platformModel.deliveryDate,
                  platformModel.deliveryPart,
                  (orders) => {
                    orderCTF.current.focus();
                    if (orders) {
                      refresh();
                      setPlatformModel({
                        ...platformModel,
                        orderID: "",
                        deliveryDate: orders.deliveryDate.split("T")[0],
                        deliveryPart: orders.deliveryPart,
                      });
                      setOrderRes(orders);
                    } else {
                      setOrderRes();
                    }
                  },
                  false
                );
              });
            }}
          >
            بله
          </Button>
          <Button color="secondary" onClick={() => setOpenDialog(false)}>
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={deleteState.show}
        onClose={() => setDeleteState({ ...deleteState, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          آیا از {deleteState.name} سفارش اطمینان دارید ؟
        </DialogTitle>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() => {
              // return;
              setProgress(true);
              CancelDeliveryOrder(deleteState.model, () => {
                refresh();
                setDeleteState({ ...deleteState, show: false });
              });
            }}
          >
            بله
          </Button>
          <Button
            color="secondary"
            onClick={() => setDeleteState({ ...deleteState, show: false })}
          >
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ height: "85%" }}>
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={
            orderRes?.pageCondition?.pageCount
              ? orderRes.pageCondition.pageCount
              : 20
          }
          rows={orderRes?.orders ? orderRes.orders : []}
          paginationMode="server"
          page={
            orderRes?.pageCondition?.page ? orderRes.pageCondition.page - 1 : 0
          }
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            orderRes?.pageCondition?.totalItemCount
              ? orderRes.pageCondition.totalItemCount
              : 0
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              nofab: true,
              isLtr: true,
              rowCount: orderRes?.pageCondition.totalItemCount
                ? orderRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "&  .MuiDataGrid-row.Mui-selected": {
              backgroundColor: "#fff",
            },
            "&  .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "&  .MuiDataGrid-cell:focus-within ": {
              outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
            },
            "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
              {
                outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
              },
            "& .MuiDataGrid-cell:hover": {
              //   opacity: "80%",
              color: "primary.main",
              cursor: "pointer",
            },
            "& .MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !important",
            },
            "& .Green": {
              backgroundColor: "#56ff004f !important",
            },
          }}
          getRowClassName={(params) => {
            if (params.row.platformID !== 0) {
              return "Green";
            }
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: isSmall ? "column" : "row",
          justifyContent: "space-between",
          gap: 2,
          height: "15%",
          mt: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            width: isSmall ? "100%" : "40%",
          }}
        >
          <TextField
            inputRef={orderCTF}
            sx={{
              width: "60%",
              input: {
                textAlign: "center",
              },
            }}
            size="small"
            id="outlined-basic"
            value={platformModel.orderID ? platformModel.orderID : ""}
            label="سفارش"
            fullWidth
            variant="outlined"
            onChange={(event) => {
              setPlatformModel({
                ...platformModel,
                orderID: event.target.value,
              });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Autocomplete
            size="small"
            onChange={(evt, newValue) => {
              if (newValue) {
                setPlatformModel({
                  ...platformModel,
                  platformid: newValue - 1,
                });
              } else {
                setPlatformModel({
                  ...platformModel,
                  platformid: undefined,
                });
              }
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option) {
                return platforms?.find((m) => m.id == option).title;
              }
              return "";
            }}
            fullWidth
            options={platforms?.map((m) => m.id)}
            renderInput={(params) => (
              <TextField
                //   error={errorState.id}
                variant="outlined"
                {...params}
                label="لجستیک"
              />
            )}
          />
          <Button
            sx={{ width: "90px" }}
            variant="contained"
            onClick={() => {
              if (!platformModel.deliveryDate && !platformModel.deliveryPart) {
                enqueueSnackbar("تاریخ و پارت ارسال را وارد کنید", {
                  variant: "error",
                  autoHideDuration: 2000,
                  preventDuplicate: true,
                });
                return;
              }
              if (!platformModel.orderID) {
                enqueueSnackbar("سفارش را وارد کنید", {
                  variant: "error",
                  autoHideDuration: 2000,
                  preventDuplicate: true,
                });
                return;
              }
              if (platformModel.platformid == undefined) {
                enqueueSnackbar("لجستیک ارسال را وارد کنید", {
                  variant: "error",
                  autoHideDuration: 2000,
                  preventDuplicate: true,
                });
                return;
              }

              // return;
              AddPlatform(platformModel, (callback) => {
                setProgress(true);
                getOrdersByDeliveryDate(
                  myPc,
                  platformModel.deliveryDate,
                  platformModel.deliveryPart,
                  (orders) => {
                    orderCTF.current.focus();
                    if (orders) {
                      setPlatformModel({
                        ...platformModel,
                        orderID: "",
                        deliveryDate: orders.deliveryDate.split("T")[0],
                        deliveryPart: orders.deliveryPart,
                      });
                      setOrderRes(orders);
                    } else {
                      setOrderRes();
                    }
                  },
                  false
                );
              });
            }}
          >
            انتقال
          </Button>
        </Box>
        <Button
          onClick={() => {
            if (!platformModel.deliveryDate && !platformModel.deliveryPart) {
              enqueueSnackbar("تاریخ و پارت ارسال را وارد کنید", {
                variant: "error",
                autoHideDuration: 2000,
                preventDuplicate: true,
              });
              return;
            }

            if (platformModel.platformid == undefined) {
              enqueueSnackbar("لجستیک ارسال را وارد کنید", {
                variant: "error",
                autoHideDuration: 2000,
                preventDuplicate: true,
              });
              return;
            }

            setOpenDialog(true);
          }}
          sx={{ width: "90px" }}
          color="secondary"
          variant="contained"
        >
          انتقال همه
        </Button>
      </Box>
    </Box>
  );
}
